// export const API_URL = "http://178.32.193.255:5001";

export const API_URL = "https://api-backend.playmaker-club.com";

// export const API_URL = "http://localhost:5001";
